import React, { useEffect, useRef, useState } from "react"
import {
  Button,
  Card,
  Col,
  Form,
  FormFeedback,
  FormGroup,
  Label,
  PopoverBody,
  Row,
  UncontrolledPopover,
} from "reactstrap"
import UpdateTable from "../../../components/Common/UpdatedTable"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import action from "../../../assets/icons/action.svg"
import { toastError, toastSuccess } from "../../../helpers/msg_helper"
import { FormProvider, useForm } from "react-hook-form"
import { UFInput } from "../../../components/Common/Fields/Input"
import { yupResolver } from "@hookform/resolvers/yup"
import * as yup from "yup"
import LoadingButton from "../../../components/Common/LoadingButton"
import {
  fetchGratuityEdit,
  fetchHrmsGratuity,
  postHrmsGratuity,
  updateGratuityStatus,
} from "../../../services/Hrms/hrms"
import HrmsSearch from "../search"
import { useLocation } from "react-router-dom"

const schema = yup.object().shape({
  gratuity: yup.string().required("Gratuity is Required"),
})
const Gratuity = () => {
  const companyname = localStorage.getItem('companyname')
  document.title = `Gratuity Lists${companyname ? ` | ${companyname}` : 'MEP -Hub'}`;

  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
  } = useForm({
    resolver: yupResolver(schema),
  })
  const methods = useForm({
    resolver: yupResolver(schema),
    mode: "onChange",
    shouldFocusError: true,
    defaultValues: {
      gratuity: "",
    },
  })
  const [isLoading, setIsLoading] = useState(false)

  const locations = useLocation();
  const crumb = locations?.state?.menuLabel || ""

  const [page, setPage] = useState("")

  const [gratuityList, setGratuity] = useState()
  const [count, setCount] = useState(0)
  const [search, setSearch] = useState("")
  const [editGratuity, setEditGratuity] = useState("")
  const [dataPerPage, setDataPerPage] = useState(25)
  const [isLoadingNextPage, setIsLoadingNextPage] = useState(false)

  useEffect(() => {
    const fetchData = async () => {
      const response = await fetchHrmsGratuity({
        params: `${search ? `&searchText=${search}` : "&searchText"}${page ? `&page=${page}` : ""
          }${`&sortOrder=asc`}${dataPerPage ? `&sizePerPage=${dataPerPage}` : ""}`,
      })
      // setGratuity(response)
      const newData = response?.data?.data || [];

      setGratuity(prev =>
        page > 1 && prev
          ? {
            ...response,
            data: {
              ...response.data,
              data: [...(prev.data?.data || []), ...newData],
            },
          }
          : response
      );
      setIsLoadingNextPage(response == undefined ? true : false)
      isLoadingRef.current = false;
    }
    fetchData()
  }, [count, search, page, dataPerPage])

  const tableContainerRef = useRef(null)
  const isLoadingRef = useRef(false);
  const scrollTimeoutRef = useRef(null);

  useEffect(() => {
    const handleScroll = (e) => {
      const { scrollTop, scrollHeight, clientHeight } = e.target;
      
      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current);
      }
      
      scrollTimeoutRef.current = setTimeout(() => {
        if (
          scrollTop + clientHeight >= scrollHeight - 50 &&
          !isLoadingRef.current &&
          page < gratuityList?.data?.last_page
        ) {
          isLoadingRef.current = true;
          setIsLoadingNextPage(true);
          setPage(prev => prev + 1);
        }
      }, 200);
    };
    
    const container = tableContainerRef.current;
    if (container) {
      container.addEventListener("scroll", handleScroll);
    }
    
    return () => {
      if (container) {
        container.removeEventListener("scroll", handleScroll);
      }
      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current);
      }
    };
  }, [gratuityList, page]);

  useEffect(() => {
    if (editGratuity.id) {
      reset({ ...editGratuity })
    }
  }, [editGratuity.id])

  const handleGratuity = async data => {
    try {
      setIsLoading(true)
      const createdSeries = await postHrmsGratuity(data)
      toastSuccess(createdSeries?.message)
      reset({
        gratuity: "",
      })
      setCount(count + 1)
    } catch (err) {
      toastError(err?.message)
    } finally {
      setIsLoading(false)
      setEditGratuity("")
    }
  }

  const handleEdit = async item => {
    const response = await fetchGratuityEdit(item)
    setEditGratuity(response?.data)
  }

  const handleSizePerPageChange = size => {
    setDataPerPage(size)
  }

  const handleStatus = async id => {
    try {
      const response = await updateGratuityStatus(id)
      toastSuccess(response?.message)
      setCount(count + 1)
    } catch (err) {
      toastError(err?.message)
    }
  }

  const columns = [
    {
      label: "Gratuity",
      renderCell: item => (
        <div className="capitalize-letter">{item?.gratuity}</div>
      ),
      sortKey: "gratuity",
    },
    {
      label: "Status",
      renderCell: item => (
        <div>
          <div
            className={`font-13 ${item?.status === 1 ? "status-active" : "status-inactive"
              }`}
          >
            {item?.status === 1 ? "Active" : "Inactive"}
          </div>
        </div>
      ),
    },
    {
      label: "Action",
      renderCell: item => (
        <>
          <div>
            <span id={`PopoverLegacy-${item?.id}`}>
              <img src={action} alt="" className="pointer" />
            </span>
          </div>
          <UncontrolledPopover
            placement="bottom"
            target={`PopoverLegacy-${item?.id}`}
            trigger="legacy"
          >
            <PopoverBody>
              {item?.status === 1 && (
                <div
                  className="table-popup-content"
                  onClick={() => handleEdit(item?.id)}
                >
                  Edit
                </div>
              )}
              <div
                className={`${item?.status === 1 ? "popover-border" : ""
                  } table-popup-content`}
                onClick={() => handleStatus(item?.id)}
              >
                {item?.status === 1 ? "Deactivate" : "Activate"}
              </div>
            </PopoverBody>
          </UncontrolledPopover>
        </>
      ),
    },
  ]

  const handlePaginate = page => {
    setPage(page)
  }

  const handleSearchChange = data => {
    setSearch(data)
    setPage(1)
  }

  const handleCancel = () => {
    reset({
      gratuity: "",
    })
    setEditGratuity("")
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <div className="d-flex justify-content-between">
            <Breadcrumbs
              title="HRMS"
              breadcrumbObject={[
                { title: "HRMS", link: "/hrms" },
                { title: crumb || "Masters", link: "/hrms" },
                { title: "Gratuity Lists", link: "/hrms-gratuity" },
              ]}
            />
          </div>

          <Row className="mt-2">
            <Col xs={5}>
              <Card className="me-2 px-2 pb-2 input-card">
                <div className="input-card-head edittheamtitle">
                  {editGratuity?.id ? "Edit" : "Add"}
                </div>
                <hr className="table-divide" />
                <FormProvider {...methods}>
                  <Form id={`ev-form`} onSubmit={handleSubmit(handleGratuity)}>
                    <Row className="mt-2">
                      <Col sm={12}>
                        <FormGroup className="mb-4">
                          <Label>
                            Gratuity<span className="mandatory">*</span>
                          </Label>
                          <UFInput
                            control={control}
                            placeholder="Enter the Gratuity"
                            name={"gratuity"}
                            invalid={!!errors.gratuity}
                          />
                          <FormFeedback invalid>
                            {errors.gratuity?.message}
                          </FormFeedback>
                        </FormGroup>
                        <div className="float-end">
                          <Button
                            className="btn-secondary me-2"
                            form={`ev-form`}
                            color={"secondary"}
                            onClick={handleCancel}
                          >
                            Cancel
                          </Button>
                          <LoadingButton
                            form={`ev-form`}
                            color={"primary"}
                            loading={isLoading}
                            disabled={isLoading}
                            type="submit"
                          >
                            {editGratuity?.id ? "Update" : "Create"}
                          </LoadingButton>
                        </div>
                      </Col>
                    </Row>
                  </Form>
                </FormProvider>
              </Card>
            </Col>
            <Col xs={7}>
              <Card className="me-2 px-2 pb-2">
                <HrmsSearch
                  handleSearchChange={handleSearchChange}
                  placeholder="Gratuity"
                />
                <hr className="table-divide" />
                <Row className="mt-2 ever-rise-table">
                  <Col xs={12}>
                  <div ref={tableContainerRef} style={{ maxHeight: "490px", overflowY: "auto" }}>
                    {gratuityList?.data?.data && (
                      <UpdateTable
                        className="mt-5"
                        nodes={gratuityList?.data?.data}
                        paginate={gratuityList?.data}
                        columns={columns}
                        CurrentPage={page}
                        handleSizePerPage={handleSizePerPageChange}
                        handlePagination={handlePaginate}
                        tableWidth="40% 45% 15%"
                        isLoading={isLoadingNextPage}
                        hidePaginate={true}
                        position={true}
                      />
                    )}
                    </div>
                  </Col>
                </Row>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  )
}

export default Gratuity
